import { DsrActionIcon } from '@main/pc-core-components/src/DsrActionIcon';
import { DefinedMessage } from '@transcend-io/internationalization';
import { RequestAction } from '@transcend-io/privacy-types';
import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { actionButtonMessages } from './messages';
import {
  ActionButtonWrapper,
  DescriptionWrapper,
  FocusButtonWrapper,
  HeaderWrapper,
  IconWrapper,
  StepWrapper,
  TextWrapper,
  TopWrapper,
} from './wrappers';

/**
 * Props for the Action Button component
 */
export interface ActionButtonProps {
  /** Title of the message */
  title: DefinedMessage;
  /** Description of the message */
  description: DefinedMessage;
  /** Type of action */
  type?: RequestAction;
  /** DSR icon */
  icon?: string;
  /** The callback function when the action button is clicked */
  onClick: () => void;
  /** A step indicator for two-step request types */
  stepMessage?: MessageDescriptor | null;
  /** Choice should be disabled */
  disabled?: boolean;
  /** For SS wizard, whether the action is selected or not */
  selected?: boolean;
}

/**
 * An option in the Take Control modal that lets users decide what to do with their data
 */
export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  title,
  description,
  stepMessage = actionButtonMessages.twoStep,
  icon,
  type,
  disabled,
  selected,
}) => {
  const { formatMessage } = useIntl();
  return (
    <FocusButtonWrapper
      buttonType="primary"
      onClick={
        disabled
          ? undefined
          : type
            ? onClick
            : (e) => {
                e.preventDefault();
                onClick();
              }
      }
    >
      <ActionButtonWrapper
        disabled={disabled}
        selected={selected}
        id={`select-dsr-action-${type}`}
        className={`action-button${selected ? ' active' : ''}`}
      >
        <TopWrapper>
          {icon ? (
            <IconWrapper src={icon} />
          ) : type ? (
            <DsrActionIcon type={type} />
          ) : null}
          {stepMessage && (
            <StepWrapper className="action-step" disabled={disabled}>
              {formatMessage(stepMessage)}
            </StepWrapper>
          )}
        </TopWrapper>
        <TextWrapper>
          <HeaderWrapper>{formatMessage(title)}</HeaderWrapper>
          <DescriptionWrapper>{formatMessage(description)}</DescriptionWrapper>
        </TextWrapper>
      </ActionButtonWrapper>
    </FocusButtonWrapper>
  );
};
